<div class="confirm-form-container">
  <div class="scroll-cont" [class.no-flex-dates]="hiddenFlexDate">
    <div class="description" *ngIf="!isUpdateForm">
        {{ 'GENERAL_WIDGET_MODULE.ALERTS.CONFIRM.DESCRIPTION' | transloco }}
    </div>
    <div class="trip-container">
      <div class="arrival-container">
        <div>
          {{ 'GENERAL_WIDGET_MODULE.ALERTS.CONFIRM.ARRIVAL_LABEL' | transloco | uppercase }}
        </div>
        <div>
          {{arrivalPlace | capitalize }}
        </div>
      </div>
      <div class="dates-container">
        <div>
          {{ 'GENERAL_WIDGET_MODULE.ALERTS.CONFIRM.DATES' | transloco | uppercase  }}
        </div>
        <div>
          {{ tripDates | titlecase }}
        </div>
      </div>
    </div>
    <div class="config-alert-title">
      {{ 'GENERAL_WIDGET_MODULE.ALERTS.CONFIRM.' + createOrUpdateTitle | transloco }}
    </div>
    <div class="actions" *ngIf="!!priceForm">
      <app-form-currency-input
        [form]="priceForm"
        [formControlSelector]="priceItemForm"
        [id]="priceItemForm"
        [isSubmitted]="isSubmitted"
        [placeholder]="'GENERAL_WIDGET_MODULE.ALERTS.CONFIRM.PRICE_PLACEHOLDER' | transloco">
      </app-form-currency-input>
    </div>
    <div class="actions check-list" [class.no-flex-dates]="hiddenFlexDate">
      <fieldset class="input" [class.last]="hiddenFlexDate">
        <app-ds-checkbox
          [align]="alignCheckboxes.Right"
          [checked]="directOnly"
          [title]="{ Label: 'GENERAL_WIDGET_MODULE.ALERTS.CONFIRM.DIRECT_FLIGHTS' | transloco }"
          (checkboxOnChecked)="setDirectOnly()">
        </app-ds-checkbox>
      </fieldset>
      <fieldset class="input last" *ngIf="!hiddenFlexDate">
        <app-ds-checkbox
          [align]="alignCheckboxes.Right"
          [checked]="flexDates"
          [title]="{ Label: 'GENERAL_WIDGET_MODULE.ALERTS.CONFIRM.FLEX_DATES' | transloco }"
          (checkboxOnChecked)="setFlexDates()">
        </app-ds-checkbox>
      </fieldset>
    </div>
  </div>
</div>

<div class="button-container">
  <app-fixed-surface>
    <app-ds-button
      [labels]="{ ButtonLabel: buttonLabel | transloco }"
      (clickEvent)="createAlertEvent()">
    </app-ds-button>
  </app-fixed-surface>
</div>
